import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Table, TableHeader, TableBody, TableRow, TableHead, TableCell } from "@/components/ui/table";
import { MoneyCell } from "./money";

const TITLES = { awarded: "Awarded Estimations", bids: "Active Bids", lost: "Lost Estimations", cancelled: "Cancelled / Rejected Estimations" };
const fmt = (v) => new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 0 }).format(v || 0);

export const MetricDrillDialog = ({ bucketKey, bucket, periodLabel, onClose }) => (
  <Dialog open={!!bucketKey} onOpenChange={(o) => !o && onClose()}>
    <DialogContent className="max-w-5xl bg-white max-h-[85vh] overflow-y-auto" data-testid="sales-metric-drill-dialog">
      <DialogHeader>
        <DialogTitle className="text-md3-headline-small">
          {TITLES[bucketKey]} · {periodLabel}
        </DialogTitle>
        <p className="text-sm text-gray-600" data-testid="sales-metric-drill-summary">
          {bucket?.count || 0} estimation{bucket?.count === 1 ? "" : "s"} · {fmt(bucket?.value)} (USD)
          {bucket?.by_currency?.CAD?.count > 0 && ` · includes C$${Math.round(bucket.by_currency.CAD.value).toLocaleString("en-US")} CAD`}
        </p>
      </DialogHeader>
      {!bucket?.items?.length ? (
        <p className="text-center py-8 text-gray-500">No estimations in this period</p>
      ) : (
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>{bucketKey === "awarded" ? "Awarded" : bucketKey === "cancelled" ? "Status Date" : "Submitted"}</TableHead>
              <TableHead>Estimation #</TableHead>
              <TableHead>Client</TableHead>
              <TableHead>Project Name</TableHead>
              <TableHead>Salesperson</TableHead>
              <TableHead className="text-right">Value</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {bucket.items.map((r) => (
              <TableRow key={r.id} data-testid={`sales-metric-drill-row-${r.id}`}>
                <TableCell className="whitespace-nowrap">{(bucketKey === "awarded" ? r.awarded_date : bucketKey === "cancelled" ? (r.status_date || r.submitted_date) : r.submitted_date) || "-"}</TableCell>
                <TableCell className="whitespace-nowrap">
                  <div className="font-medium">{r.estimation_number}</div>
                  <div className="text-xs text-gray-500">v{r.version}</div>
                </TableCell>
                <TableCell>
                  {r.client_name}
                  {r.is_partial && <div className="text-[10px] uppercase tracking-wide text-emerald-700 font-semibold">Partial — {bucketKey === "awarded" ? "awarded items" : bucketKey === "lost" ? "lost items" : "pending items"}</div>}
                </TableCell>
                <TableCell>
                  {r.project_name}
                  {bucketKey === "cancelled" && r.sales_tracking_status && <div className="text-[10px] uppercase tracking-wide text-gray-500 font-semibold">{r.sales_tracking_status}</div>}
                </TableCell>
                <TableCell>{r.sales_person_name}</TableCell>
                <TableCell className="text-right"><MoneyCell usd={r.value} native={r.native_value} currency={r.currency} /></TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      )}
    </DialogContent>
  </Dialog>
);
